export default class GameSoundService {
    constructor(game) {
        this.player = new Audio();
        this.player.volume = 0.5;
    }

    play(sound) {
        this.player.src = sound;

        try {
            this.player.play();
        } catch (error) {
            console.log(error);
        }
    }
}
